<template>
  <div id="pageName">
    <p class="pageName"><span>Step{{step}}</span>{{pageTitle[step-1]}}</p>
  </div>
</template>

<script>
export default {
  name: 'page-name',
  props: [
    "step",
    "pageTitle"
  ]
}
</script>

<style scoped lang="scss">
#pageName {
  margin-top: 60px;
  margin-bottom: 40px;
  font-family: 游明朝,"Yu Mincho",YuMincho,"Hiragino Mincho ProN",HGS明朝E,メイリオ,Meiryo,serif;
}
.pageName {
  padding: 0 15px;
  font-size: 25px;
  font-weight: 500;
  line-height: 0.92;
  color: #333333;
  text-align: center;
  @media (max-width: 767.98px) {
    font-size: 23px;
  }
}
span {
  font-family: 'Tangerine', cursive !important;
  font-size: 60px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 0.38;
  letter-spacing: normal;
  text-align: left;
  margin-right: 10px;
  color: #a18720;
  @media (max-width: 767.98px) {
    font-size: 50px;
  }
}

</style>
